module.exports = __webpack_public_path__ + "static/media/th.565e3c4b.svg";